import React from "react";
import styled from "styled-components";
import girl from "../../assets/img/girl9.png";
import AnimatedShapes from "../AnimatedShapes";

const Container = styled.div`
  height: calc(100vh - 50px);
  display: flex;
  padding: 20px;
  @media only screen and (max-width: 480px) {
    width: 90%;
    flex-direction: column;
    justify-content: center;
  }
`;

const Left = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 480px) {
    width: 100%;
  }
`;
const Title = styled.h1`
  font-size: 60px;
  width: 60%;
  @media only screen and (max-width: 480px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 30px;
  }
`;
const Desc = styled.div`
  width: 60%;
  font-size: 20px;
  margin-top: 20px;
  @media only screen and (max-width: 480px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 20px;
  }
`;
const Button = styled.div`
  padding: 15px;
  background-color: darkblue;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px;
  border: none;
  letter-spacing: 2px;
  cursor: pointer;
  width: 200px;
  text-align: center;
  &:hover {
    background-color: blue;
  }
`;

const Info = styled.div`
  width: 60%;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 480px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 480px) {
    padding-top: 20px;
  }
`;
const Phone = styled.div`
  color: #f0667d;
  font-weight: bold;
`;
const ContactText = styled.div`
  color: gray;
  padding-top: 5px;
`;

const Right = styled.div`
  width: 40%;
`;

const Image = styled.img`
  width: 100%;
  padding-top: 120px;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const Link = styled.a`
  color: white;
  text-decoration: none;
`;

const Intro = () => {
  return (
    <Container id="Home">
      <Left>
        <Title>Adventures in creative age</Title>
        <Desc>
          We believe that designing products and services in close partnership
          with our clients is the only way to have a real impact on their
          business.
        </Desc>
        <Info>
          <Button>
            <Link href="https://tn.linkedin.com/in/mahmoud-ayed-111329207">
              Start a project
            </Link>
          </Button>
          <Contact>
            <Phone>Call Us (+216) 51.547.900 </Phone>
            <ContactText>For any question or concern</ContactText>
          </Contact>
        </Info>
      </Left>
      <Right>
        <Image src={girl} alt="intro-photo" />
      </Right>
      <AnimatedShapes />
    </Container>
  );
};

export default Intro;
